import * as Constants from '../constants';

const ENDPOINTS = {
		
	GET_USUARIOS: (establecimientoId, userRol) => { 
		let url = '/api/v1/usuarios/establecimiento/' + establecimientoId;
		
		if (userRol === Constants.ROLE_USUARIO_ADMINISTRADOR) {
			url += "?userRol=" + userRol
		}
		
		return url;
	},
		
	GET_TIPOS_USUARIO: () =>
		'/api/v1/usuarios/tiposUsuarios/',
		
	GET_TIPOS_USUARIO_BY_PARAMS: (establecimientoId, activo, nombre, idTipo, userRol) => {
		let url = '/api/v1/usuarios/establecimiento/' + establecimientoId +
		'?estado=' + activo +
		'&nombre:ct=' + nombre
		
		if (idTipo != "" && idTipo != null) {
			url += '&idTipoEmpleado=' + idTipo
		}
		
		if (userRol === Constants.ROLE_USUARIO_ADMINISTRADOR) {
			url += '&userRol=' + userRol
		}
		
		return url;
	},
	
	GET_TIPOS_USUARIO_BY_USER_ROLE: (role) => {
		let url = '/api/v1/usuarios/tiposUsuarios/' + 
		'?userRol=' + role 
		
		return url;
	},
	
	CREATE_USUARIO_ADMIN: () =>
		'/api/v1/usuarios/administradores/',

	UPDATE_USUARIO_ADMIN: (id) =>
		'/api/v1/usuarios/administradores/' + id,

	DELETE_USUARIO_ADMIN: (id) =>
		'/api/v1/usuarios/administradores/' + id,

	CREATE_USUARIO_ADMIN_CADENA: () =>
		'/api/v1/usuarios/admincadena/',

	UPDATE_USUARIO_ADMIN_CADENA: (id) =>
		'/api/v1/usuarios/admincadena/' + id,

	DELETE_USUARIO_ADMIN_CADENA: (id) =>
		'/api/v1/usuarios/admincadena/' + id,

	CREATE_USUARIO_GESTOR: () =>
		'/api/v1/usuarios/gestores/',

	UPDATE_USUARIO_GESTOR: (id) =>
		'/api/v1/usuarios/gestores/' + id,

	DELETE_USUARIO_GESTOR: (id) =>
		'/api/v1/usuarios/gestores/' + id,

	CREATE_USUARIO_TRABAJADOR: () =>
		'/api/v1/usuarios/trabajadores/',

	UPDATE_USUARIO_TRABAJADOR: (id) =>
		'/api/v1/usuarios/trabajadores/' + id,

	DELETE_USUARIO_TRABAJADOR: (id) =>
		'/api/v1/usuarios/trabajadores/' + id,

	GET_TIPOS_USUARIOS: () =>
		'/api/v1/usuarios/tiposUsuarios',

	ASIGNAR_HABITACIONES: () =>
		'/api/v1/habitaciones/asignar',
	
	GET_USUARIO_BY_ID: (id) =>
		'/api/v1/usuarios/' + id,
	
	OBTENER_TOKEN_PWD: (email) =>
		'/api/v1/usuarios/password/token?email=' + email,
	
	RESTABLECER_PWD: (password, token) => 
		'/api/v1/usuarios/password?password=' + password + '&token=' + token
};

export default ENDPOINTS;